export default __webpack_public_path__ + "static/media/cart1.782e8602.jpg";